import client from '../request'

const getAll = `/scanners`

const get = (id) => {
  return `/scanners/${id}`
}

const create = (data) => {
  return client.post('/scanners', data)
}

const update = (id, data) => {
  return client.put(`/scanners/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/scanners/${id}`)
}

const ScannerService = {
  getAll,
  get,
  create,
  update,
  toRow,
  remove,
  toPaginate
}

export default ScannerService
